import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../interpretation/interpretation.service';
import { InterpretationreportService } from '../interpretationreport.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-send-hirereport-dialog',
  templateUrl: './send-hirereport-dialog.component.html',
  styleUrls: ['./send-hirereport-dialog.component.scss']
})
export class SendHirereportDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<SendHirereportDialogComponent>,
    private _interpretationReportService: InterpretationreportService,
    @Inject(MAT_DIALOG_DATA) public data: any,      
    private _notify: NotificationsService,
    private _interp: InterpretationService,
        
    ) { }

  emailAddress: string = "";
  validEmailString: boolean = false;
  customerName: string = "";
  id:number=0
  id2:number=0
  saving: boolean = false;
  emailForm: FormGroup;
  customerNameInput: FormControl;
  emailInput: FormControl;

  ngOnInit() {

    this.id = this.data.id;
    this.id2 = this.data.id2;


    this.customerNameInput = new FormControl('', [
        Validators.required,
    ]);

    this.emailInput = new FormControl('', [
        Validators.required,          
    ]);
    
    this.emailForm = new FormGroup({
        customerNameInput: this.customerNameInput,
        emailInput: this.emailInput,
    });

  }

  
  onCloseClick(): void {
    this.dialogRef.close();
}


checkEmailAddress() {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  this.validEmailString = re.test(String(this.emailAddress).toLowerCase());
}

saveChanges() {
 
    this._interp.SendHireReport(this.id, this.id2, this.emailAddress, this.customerName).subscribe(res => {
      //  this._loading.finishedLoading();
        this.saving = false;
        if (res != null && res == true) {
            this.dialogRef.close();
        
          this._notify.success('Successfully sent report.');

        } else {
           
            this._notify.error('Failed to send report!');

        }
    });
    if (this.validEmailString && this.emailAddress.length > 0) {
        this.dialogRef.close({
            data: this.emailAddress
        });
    }
}
}
